import apiClient from './client';

export interface EventCategory {
  category: string;
  startDate: string;
  endDate: string;
}

export interface Competition {
  id: string;
  name: string;
  description?: string;
  tournamentNumber?: string;
  ltaLink?: string;
  eventCategories?: string; // JSON string
  startDate: string;
  endDate: string;
  location?: string;
  grade?: string;
  createdBy: string;
  createdAt: string;
  results?: CompetitionResult[];
}

export interface CompetitionResult {
  id: string;
  competitionId: string;
  playerId: string;
  position?: number;
  score?: string;
  notes?: string;
  player?: {
    id: string;
    firstName: string;
    lastName: string;
  };
}

export interface CreateCompetitionData {
  name: string;
  description?: string;
  tournamentNumber?: string;
  ltaLink?: string;
  eventCategories?: EventCategory[];
  startDate: string;
  endDate: string;
  location?: string;
  grade?: string;
}

export const competitionApi = {
  getCompetitions: () => {
    return apiClient.get('/competitions');
  },

  getCompetitionById: (id: string) => {
    return apiClient.get(`/competitions/${id}`);
  },

  createCompetition: (data: CreateCompetitionData) => {
    // Convert eventCategories array to JSON string
    const payload = {
      ...data,
      eventCategories: data.eventCategories ? JSON.stringify(data.eventCategories) : undefined,
    };
    return apiClient.post('/competitions', payload);
  },

  updateCompetition: (id: string, data: Partial<CreateCompetitionData>) => {
    const payload = {
      ...data,
      eventCategories: data.eventCategories ? JSON.stringify(data.eventCategories) : undefined,
    };
    return apiClient.put(`/competitions/${id}`, payload);
  },

  deleteCompetition: (id: string) => {
    return apiClient.delete(`/competitions/${id}`);
  },

  addPlayer: (competitionId: string, playerId: string) => {
    return apiClient.post(`/competitions/${competitionId}/players`, { playerId });
  },

  updateResult: (competitionId: string, playerId: string, data: { position?: number; score?: string; notes?: string }) => {
    return apiClient.put(`/competitions/${competitionId}/results/${playerId}`, data);
  },
};
